import React, { useState } from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import cui from 'components/cui/cui';
import ic_visibility from 'assets/imgs/ic_visibility.png';

const regexNumb = /^[0-9]*$/;

const InputText = ({ value, name, title, handleOnChange, onEnter, autoFocus, placeholder, extensionClass,
  onlyNumber, isPassword, errorMsg, customClass, customTitle, isTwoLine, readOnly }) => {

  const [visible, setVisible] = useState(true);

  const onChange = (e) => {
    const { value } = e.target;

    if (!onlyNumber || value === '') {
      handleOnChange(value, name);
      return;
    }
    
    if (regexNumb.test(value)) {
      handleOnChange(value, name);
    }
  }

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      onEnter();
    } else if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
  }

  return (
    <>
      <div className={`input-text ${customClass || ''} ${isTwoLine ? 'two-line' : ''}`}>
        {title && <span className={`input-text__title ${customTitle || ''}`}>{title}</span>}
        <input
          type={onlyNumber ? "tel" : (isPassword && visible) ? "password" : "text"}
          className={`${extensionClass || ''} ${errorMsg && 'border-red'}`}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={handleOnKeyDown}
          autoFocus={autoFocus}
          readOnly={readOnly}
        />
        {isPassword &&
          <img alt="icon" src={ic_visibility} onClick={() => setVisible(!visible)} />
        }
      </div>
      {!cui.isUndefinedOrNull(errorMsg) &&
        <div className="err-msg">{errorMsg}</div>
      }
    </>
  );
}

InputText.propTypes = {
  value: PropTypes.any,
  handleOnChange: PropTypes.func,
  onEnter: PropTypes.func
};

InputText.defaultProps = {
  value: '',
  handleOnChange: () => { },
  onEnter: () => { }
};

export default React.memo(InputText);
